<file-input (imageChanged)="eventImageChanged($event)"></file-input>


<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Schließen</button>
    <button (click)="save()" mat-button>Speichern</button>
</mat-dialog-actions>
